import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import BentoOverview from '../../components/analytics/BentoOverview';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { useSettings } from '../../contexts/SettingsContext';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';

/**
 * Analytics Page Component
 * Comprehensive analytics dashboard - simplified overview
 */
const Analytics = () => {
  const { period, setPeriod, platform, setPlatform } = useFilterPersistence({
    pageKey: 'analytics',
    defaultPeriod: FILTER_PERIODS.ALL,
    defaultPlatform: null
  });
  const settings = useSettings();
  const compact = settings.compactMode;

  // Simplified analytics - just show overview with all metrics
  // Individual sections now have their own pages

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
      platform={platform}
      onPlatformChange={setPlatform}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.ANALYTICS.title}
        description={PAGE_INFO.ANALYTICS.description}
        filters={filters}
      >
        <div className="analytics-content">
          <BentoOverview period={period} platform={platform} compact={compact} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Analytics;